import {ObjectUtil} from '../util/object-util';

export class ExpertService {
  expertServiceId: string = null;
  name: string = null;
  number: string = null;

  constructor(object?: any) {
    ObjectUtil.assign(this, object);
  }

}
